import styled from "styled-components";
import colors from "../config/colors";
import media from "../config/mediaQueries";

const Headline = styled.h1`
  font-size: 2rem;
  font-weight: 500;
  color: ${({ color }) => (color ? colors[color] : colors.text)};
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  margin: 1rem 0 2rem;
  line-height: 1.3;
  ${media.desktop`
    font-size: ${({ responsive }) => (responsive ? "4vw" : "2rem")};
  `};
`;

export default Headline;



// WEBPACK FOOTER //
// ./src/components/Headline.js